<template>
  <v-flex>
    <div class="p-t-20">
      <div class="tituloBox border-top">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Sócios</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="headers"
      :items="sociosLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1 tableAprovarRejeitar"
    >
      <template slot="items" slot-scope="props">
        <tr
          v-bind:class="{'item-aprovado':(props.item.habilitacaoJuridicaSituacao==2),'item-reprovado':(props.item.habilitacaoJuridicaSituacao==1)}"
        >
          <td nowrap class="text-center">
            <v-tooltip top>
              <v-icon @click="editarItem(props.item)" class="mx-1" slot="activator">edit</v-icon>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="aprovarHabilitacao(props.item,2)"
                class="mx-1"
                slot="activator"
                color="green"
              >spellcheck</v-icon>
              <span>Aprovar</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="openModalRejeitar(props.item,1)"
                class="mx-1"
                slot="activator"
                color="red accent-4"
              >highlight_off</v-icon>
              <span>Rejeitar</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="deleteItem(props.item)"
                class="mx-1"
                slot="activator"
              >delete</v-icon>
              <span>Deletar</span>
            </v-tooltip>
          </td>
          
          <td class="text-xs-left" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
            {{ props.item.nome }}
         <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.nome,'nome')"></div>
         <div v-html="ifHabilitacaoJuridicaNova(props.item.cpfCnpj,'S')"></div>
          </td>
          <td class="text-xs-left" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}" nowrap>
            <a v-show="props.item.isFuncionarioPublico">
              <v-tooltip top>
                <v-icon class="mx-1" slot="activator" :size="20" color="red">info</v-icon>
                <span>Esse CPF pertence a um Servidor Público</span>
              </v-tooltip>
            </a>
            <input
              v-if="(props.item.flagEstrangeiro) == 0"
              v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}"
              v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
              readonly
              :value="props.item.cpfCnpj"
            />
            <input
              v-else
              v-mask="maskDocumentoIdentificacao"
              readonly
              :value="props.item.cpfCnpj"
              v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}"
            />
          </td>
          <td class="text-xs-center" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
            {{props.item.isFuncionarioPublico ? "Sim" : "Não" }}
          </td>
          <td class="text-xs-center" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
            {{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.flagEstrangeiro,'flagEstrangeiro')"></div>
            </td>
          <td class="text-xs-center" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
            {{ String(props.item.percentual).replace(".",",") }}
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.percentual,'percentual')"></div>
          </td>
          <td class="text-xs-center">
            <a
              @click="baixarDocumento(props.item.arquivoUpload)"
            >{{subStrUpload(props.item.arquivoUpload,$t("label.anexo")) | truncateString(35)}}</a>
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.arquivoUpload,'arquivoUpload')"></div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <dialogMotivoIndeferimento
      :config="modelDialogRejeitarSocio"
      v-on:observacaoOk="rejeitarHabilitacao(modelDialogRejeitarSocio.motivoSelecionado)"
      v-on:observacaoCancel="fnAcaoModalCancelar()"
    />
  </v-flex>
</template>


<script>
import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import analiseCampoAlterado from "./analiseCampoAlterado";
import sociosDirigentes from "./socios-dirigentes";
import fornecedorService from "@/services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */


export default {
  name: "socios-crud",
  mixins: [util, analiseCampoAlterado, sociosDirigentes],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    habilitacaoLista: Object,
    erroHabilitacaoJuridica: Object,
    OldModel: Object
  },
  computed: {//Campos computados
    sociosLista() {
      if (this.habilitacaoLista.sociosLista) {
        this.$emit("exclusaoListar","1");
        return this.habilitacaoLista.sociosLista.sort(function(a, b) {
          var ob1 = String(
            a.idFornecSolicitacao + "" + a.idFornecHabilitacaoJur
          );
          var ob2 = String(
            b.idFornecSolicitacao + "" + b.idFornecHabilitacaoJur
          );
          return ob1 - ob2;
        });
      }
      return null;
    }
  },
  data() {//Declaracao de variaveis
    return {
      crud: false,
      totalDesserts: 0,
      loading: false,
      modelDialogRejeitarSocio: {
        open: false,
        obs: null,
        titulo: "Motivo",
        codDocumento:0,
        motivoSelecionado:0
      },
      itemRejeitado: {},
      headers: [ /*Cabeçalho da data-table*/
        {
          text: "Ações",
          align: "center",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.nome"),
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: this.$t("label.cpfCnpj"),
          align: "left",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.socioServidor"),
          align: "left",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.brasileiro") + "?",
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: this.$t("label.percentual"),
          align: "center",
          sortable: false,
          width: 50
        },
        {
          text: this.$t("label.anexo"),
          align: "center",
          sortable: false,
          width: 120
        }
      ]
    };
  },
  methods: {//Declaracao de todos os metodos
    deleteItem(itemLista) {
      //deletar socio
      this.$emit("exclusaoListar","1");

      fornecedorService
        .deleteFornecedorHabilitacaoJuridica(itemLista.idFornecHabilitacaoJur)
        .then(response => { /*resposta do servico*/
          this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
          this.habilitacaoLista.sociosLista = [];
          this.habilitacaoLista.dirigentesLista = [];

          this.model.fornecedoresHabilitacaoJuridica.filter(item => {
            if (item.tipoCadastro === "D") {
              this.habilitacaoLista.dirigentesLista.push(item);
            } else {
              this.habilitacaoLista.sociosLista.push(item);
            }
          });
          if(!this.habilitacaoLista.sociosLista.length){
              this.erroHabilitacaoJuridica.erro=false;
          }
      });
    },
    openModalRejeitar(itemLista) {
      this.itemRejeitado = itemLista;

      this.modelDialogRejeitarSocio.open = true;
      this.modelDialogRejeitarSocio.codDocumento = itemLista.codDocumentoSIMPAS;

      this.modelDialogRejeitarSocio.motivoSelecionado = this.itemRejeitado.idMotivoIndeferimentoArquivo;
    },

    fnAcaoModalCancelar() {
      this.modelDialogRejeitarSocio.open = false;
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.v-datatable .v-tooltip {
  display: inline-flex !important;
  align-items: center;
}
</style>
